enum AbaTypeEnum {
    Fwt1SellInPrepaidInterest = 'FWT1_SELL_IN_PREPAID_INTEREST',
    Fwt2SellInPrepaidInterest = 'FWT2_SELL_IN_PREPAID_INTEREST',
}

export default AbaTypeEnum;